import { render, staticRenderFns } from "./TableCustomSort.vue?vue&type=template&id=2429ce66&scoped=true"
import script from "./TableCustomSort.vue?vue&type=script&lang=js"
export * from "./TableCustomSort.vue?vue&type=script&lang=js"
import style0 from "./TableCustomSort.scss?vue&type=style&index=0&id=2429ce66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2429ce66",
  null
  
)

export default component.exports